import React, { useState } from 'react';
import { Form, Input, Icon } from 'semantic-ui-react';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  loading?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const ChatInput: React.FC<ChatInputProps> = ({ 
  onSendMessage, 
  loading = false, 
  disabled = false,
  placeholder = "Ask anything about patient"
}) => {
  const [message, setMessage] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (message.trim() && !loading && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleIconClick = () => {
    if (message.trim() && !loading && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };
  
  return (
    <div className="chat-input-container">
      <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div className="chat-input-wrapper">
          <Input
            fluid
            size="large"
            placeholder={disabled ? "Please load a patient first..." : placeholder}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={disabled || loading}
            icon={
              <Icon 
                name={loading ? 'spinner' : 'send'} 
                loading={loading}
                link={!disabled && !loading && message.trim()}
                onClick={handleIconClick}
                style={{ 
                  color: (!disabled && !loading && message.trim()) ? '#5DBCD2' : '#ccc',
                  cursor: (!disabled && !loading && message.trim()) ? 'pointer' : 'default'
                }}
              />
            }
            className="rounded-input"
          />
        </div>
      </Form>
    </div>
  );
};

export default ChatInput;